import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { markActiveInActiveAgencyUserFailure, markActiveInActiveAgencyUserSuccess } from '../actions/markActiveInActiveAgencyUserActions';

function* markActiveInActiveAgencyUser({ payload, callback }) {
    console.log('====================================');
    console.log("MARK_ACTIVE_INACTIVE_AGENCY_USER_REQUEST payload :", payload);
    console.log("MARK_ACTIVE_INACTIVE_AGENCY_USER_REQUEST callback :", callback);
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.markActiveInActiveAgencyUser,
            payload: payload,
            isAuth: true
        });
        console.log('====================================');
        console.log("MARK_ACTIVE_INACTIVE_AGENCY_USER_SUCCESS status :", response.data.status);
        console.log("MARK_ACTIVE_INACTIVE_AGENCY_USER_SUCCESS data :", response.data.response);
        console.log("MARK_ACTIVE_INACTIVE_AGENCY_USER_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            markActiveInActiveAgencyUserSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("MARK_ACTIVE_INACTIVE_AGENCY_USER_FAILURE status :", error?.response?.status);
        console.log("MARK_ACTIVE_INACTIVE_AGENCY_USER_FAILURE data:", error?.response?.data);
        console.log("MARK_ACTIVE_INACTIVE_AGENCY_USER_FAILURE error :", error);
        console.log('====================================');
        yield put(markActiveInActiveAgencyUserFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* markActiveInActiveAgencyUserSaga() {
    yield takeLatest(actionTypes.MARK_ACTIVE_INACTIVE_AGENCY_USER_REQUEST, markActiveInActiveAgencyUser);
}

export default markActiveInActiveAgencyUserSaga;
